import dayjs from '@/lib/dayjs'
import { REPORT_DATE_MODE } from '@/lib/report-date-range'
import type { CashDrawerIdInput, CashDrawerWorkstation } from './cash-drawers.types'

export function selectBalancingWorkstation<T extends Pick<CashDrawerWorkstation, 'id'>>({
  workstations,
  requestedWorkstationId,
  pairedWorkstationId,
}: {
  workstations: T[]
  requestedWorkstationId?: CashDrawerIdInput
  pairedWorkstationId?: CashDrawerIdInput
}) {
  if (requestedWorkstationId) {
    const requestedWorkstation = workstations.find(
      (workstation) => Number(workstation.id) === Number(requestedWorkstationId)
    )

    if (requestedWorkstation) return requestedWorkstation
  }

  const pairedWorkstation = workstations.find(
    (workstation) => Number(workstation.id) === Number(pairedWorkstationId)
  )

  return pairedWorkstation ?? workstations[0] ?? null
}

export function selectBalancingSession<
  T extends { workstation: Pick<CashDrawerWorkstation, 'id'> },
>(openSessions: T[], workstationId: CashDrawerIdInput) {
  return (
    openSessions.find((session) => Number(session.workstation.id) === Number(workstationId)) ?? null
  )
}

export function formatClosedDrawerDate(value: string, timezone: string) {
  return dayjs(value).tz(timezone).format('dddd — MMMM D, YYYY')
}

export function getRegisterHistoryFilters(timezone: string, workstationId: CashDrawerIdInput) {
  const today = dayjs().tz(timezone).startOf('day')

  return {
    start_date: today.subtract(89, 'day').format('YYYY-MM-DD'),
    end_date: today.format('YYYY-MM-DD'),
    date_mode: REPORT_DATE_MODE.CUSTOM,
    workstation_id: Number(workstationId),
    sort: 'newest',
    page: 1,
  }
}
